import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { LogOut } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { api, errMsg, fmtD } from "@/lib/api";
import { PageHeader, Section, Field } from "@/components/common";

export default function Profile() {
  const { user, setUser, logout, isAdmin } = useAuth();
  const [p, setP] = useState({ name: user.name, phone: user.phone || "" });
  const [pw, setPw] = useState({ current_password: "", new_password: "", confirm_password: "" });
  const nav = useNavigate();
  const saveProfile = async (e) => {
    e.preventDefault();
    try { const r = await api.put("/auth/profile", p); setUser(r.data); toast.success("Profile updated"); } catch (ex) { toast.error(errMsg(ex)); }
  };
  const changePw = async (e) => {
    e.preventDefault();
    if (pw.new_password !== pw.confirm_password) { toast.error("New password and confirmation do not match"); return; }
    try { await api.post("/auth/change-password", pw); toast.success("Password changed"); setPw({ current_password: "", new_password: "", confirm_password: "" }); } catch (ex) { toast.error(errMsg(ex)); }
  };
  return (
    <div className="max-w-3xl">
      <PageHeader title="My profile" subtitle="Account settings">
        <button data-testid="profile-logout-button" onClick={async () => { await logout(); nav("/login"); }} className="flex h-9 items-center gap-1.5 rounded-md border px-4 text-sm font-semibold text-rose-600 hover:bg-rose-50"><LogOut className="h-4 w-4" /> Logout</button>
      </PageHeader>
      <div className="space-y-6">
        <Section title="Profile">
          <form onSubmit={saveProfile} className="grid gap-4 p-4 sm:grid-cols-2" data-testid="profile-form">
            <Field label="Name"><input data-testid="profile-name-input" required className="crm-input" value={p.name} onChange={(e) => setP({ ...p, name: e.target.value })} /></Field>
            <Field label="Phone number"><input data-testid="profile-phone-input" className="crm-input" value={p.phone} onChange={(e) => setP({ ...p, phone: e.target.value })} /></Field>
            <Field label="Email / username"><input disabled className="crm-input bg-slate-50" value={user.email} /></Field>
            <Field label="Role"><input disabled data-testid="profile-role" className="crm-input bg-slate-50" value={isAdmin ? "Sales Admin" : "Sales Employee"} /></Field>
            <p className="text-xs text-muted-foreground">Member since {fmtD(user.created_at)}</p>
            <div className="sm:col-span-2"><button data-testid="profile-save-button" className="h-9 rounded-md bg-primary px-5 text-sm font-semibold text-white hover:opacity-90">Save profile</button></div>
          </form>
        </Section>
        <Section title="Change password">
          <form onSubmit={changePw} className="grid gap-4 p-4 sm:grid-cols-3" data-testid="password-form">
            <Field label="Current password"><input data-testid="current-password-input" type="password" required className="crm-input" value={pw.current_password} onChange={(e) => setPw({ ...pw, current_password: e.target.value })} /></Field>
            <Field label="New password"><input data-testid="new-password-input" type="password" required minLength={6} className="crm-input" value={pw.new_password} onChange={(e) => setPw({ ...pw, new_password: e.target.value })} /></Field>
            <Field label="Confirm new password"><input data-testid="confirm-password-input" type="password" required className="crm-input" value={pw.confirm_password} onChange={(e) => setPw({ ...pw, confirm_password: e.target.value })} /></Field>
            <div className="sm:col-span-3"><button data-testid="change-password-button" className="h-9 rounded-md bg-slate-900 px-5 text-sm font-semibold text-white hover:bg-slate-700">Update password</button></div>
          </form>
        </Section>
      </div>
    </div>
  );
}
